// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1E2CC","label":"styles_label__2wOCr","input":"styles_input__1YbG_","error":"styles_error__2uZFX"};